import { DataRoomMember } from 'router/subrouters/DataRoom/models/DataRoomMember';

export const prepareTeamsOptions = (
  teams: string[] = [],
  allMembers: DataRoomMember[] = [],
) =>
  teams.map((team) => ({
    name: team,
    members: allMembers.filter(({ teams }) => teams?.includes(team)),
  }));
